import { isInlineOrText } from './sanitizePlateFragment';

/** Text of a text leaf or inline: links recurse into their children, mentions give their `value` label. */
function inlineText(node: any): string {
    if (typeof node?.text === 'string') return node.text;
    if (node?.type === 'mention' && typeof node.value === 'string') return node.value;
    return Array.isArray(node?.children) ? node.children.map(inlineText).join('') : '';
}

/**
 * Flatten a Plate value to plain text: one line per block (nested blocks —
 * list items, table cells — each get their own line), text and inline
 * elements (links, mentions) joined in order, marks/attributes dropped. The
 * inverse of `txtBlobToPlateValue` for the DocxDrawer's "Download as .txt" of
 * an edited .txt file.
 */
export function plateToPlainText(nodes: any[]): string {
    const lines: string[] = [];
    const walk = (node: any): void => {
        if (!node || typeof node !== 'object') return;
        if (!Array.isArray(node.children)) return;
        if (node.children.every(isInlineOrText)) {
            lines.push(node.children.map(inlineText).join(''));
            return;
        }
        node.children.forEach(walk);
    };
    (Array.isArray(nodes) ? nodes : []).forEach(walk);
    return lines.join('\n');
}
